import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import { arrayMove } from 'react-sortable-hoc';
import axios from 'axios';
import 'react-quill/dist/quill.snow.css';

import appConstant from '../../../../constants/app';
import SocialMediaLinksSortable from './footerContentView/socialMediaLinksSortable';

class FooterContentView extends PureComponent {
  state = {
    isLoaderOpened: false,
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    const token = localStorage.getItem('token');
    const {
      onChangeSocialMediaList,
      socialMedia,
    } = this.props;

    this.setState({ isLoaderOpened: true });
    
    const items = arrayMove(socialMedia, oldIndex, newIndex);

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/social-networks/positions/update?access_token=${token}`, 
      data: {
        social_networks: items.map((item, index) => ({
          id: item.id,
          position: index + 1,
        }))
      },
    })
    .then(res => {
      const items = res.data.footer.social_networks;
      onChangeSocialMediaList(items);
      this.setState({ isLoaderOpened: false });
    }).catch(err => {
      console.log(err);
    });

  };

  render() {
    const {
      onClickEdit,
      socialMedia,
      footerContent,
    } = this.props;

    return (
      <div>
        <Row className="image-bg">
          <Col sm={8}>
            <div className="text-right">
              <div className="edit-link">
                <span
                  onClick={onClickEdit}
                >
                  Edit
                </span>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="image-bg">
          <Col sm={8}>
            <h2 className="image-bg-title">Social Media</h2>
            {
              this.state.isLoaderOpened
              ? <p> Loading... </p>
              : <SocialMediaLinksSortable
                  items={socialMedia}
                  onSortEnd={this.onSortEnd}
                />
            }
          </Col>
        </Row>
        <Row className="image-bg">
          <Col sm={8}>
            <h3 className="image-bg-title">Text</h3>
            <div className="ql-editor">
              <div className="rich-text-container" dangerouslySetInnerHTML={{__html: footerContent.disclaimer_text}} /> { /* backend sanitize :)*/ }
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default FooterContentView;




// WEBPACK FOOTER //
// ./src/app/screens/general/footerContent/footerContentView.js